import { useState } from 'react'
import { useSearchParams } from 'next/navigation'
import axios from 'axios'

import Head from 'next/head'

import { useMutation } from '@tanstack/react-query'

import { Flex, Loading, Container, Input, Button } from '@fe-toolkit/web-components/ssr'

import { useAuthContext } from '@/context/AuthContext'

import { useMemberContext } from '@/context/MemberContext'
import { EPageRoutes } from '@/constants'
import logger from '@/lib/logger'
import theme from '@/theme/theme'

const Login = () => {
  const { isAuthenticated } = useAuthContext()
  const { isFetching } = useMemberContext()
  const searchParams = useSearchParams()

  const redirect = searchParams.get('redirect')

  const [mobileNumberOrMemberName, setMobileNumberOrMemberName] = useState<string>('')
  const [password, setPassword] = useState<string>('')

  const { mutateAsync: login } = useMutation({
    mutationKey: ['login'],
    mutationFn: () =>
      axios.post(EPageRoutes.LOGIN, {
        memberName: mobileNumberOrMemberName,
        password: password,
        rememberMember: false,
      }),
  })

  const handleLogin = async () => {
    try {
      const response = await login()

      if (response.status === 200) {
        window.location.replace(decodeURI(`${redirect}`))
      }
    } catch (error) {
      logger.error('Login Error', { error })
    }
  }

  const handleMobileNumberOrMemberNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMobileNumberOrMemberName(e.target.value)
  }

  const handlePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value)
  }

  if (isFetching && !isAuthenticated) {
    return (
      <Flex
        alignItems="center"
        flexDirection="column"
        justifyContent="center"
        minHeight={`calc(80vh - ${theme.layout.headerHeight})`}
      >
        <Loading />
      </Flex>
    )
  }

  return (
    <>
      <Head>
        <title>Broadband | giffgaff</title>
        <meta content="Log in page" name="description" />
      </Head>
      <Flex alignItems="center" flexDirection="column" height="100vh" justifyContent="center">
        <Container>
          <Input
            data-di-mask
            label="Mobile number or member name"
            name="memberName"
            value={mobileNumberOrMemberName}
            onChange={handleMobileNumberOrMemberNameChange}
          />
          <Input data-di-mask label="Password" name="password" value={password} onChange={handlePassword} />
        </Container>
        <Button variant="primary" onClick={handleLogin}>
          Log in
        </Button>
      </Flex>
    </>
  )
}

export default Login
